var React = require('react');

function Bath (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.5 0C4.82548 0 5.91004 1.03154 5.99468 2.33562L6 2.5V3H4V2.5C4 2.22386 3.77614 2 3.5 2C3.25454 2 3.05039 2.17688 3.00806 2.41012L3 2.5V6.00157H12L9.89815 9.94255C9.5505 10.5944 8.87185 11.0015 8.1331 11.0014L3.86631 11.0007C3.12787 11.0005 2.44959 10.5935 2.10203 9.94199L0 6.00157H1V2.5C1 1.11929 2.11929 0 3.5 0Z","fill":"#424242"}));
}

Bath.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Bath;

Bath.default = Bath;
